// import { ConnectionLineComponentProps } from 'reactflow';
// import styled from 'styled-components';

// const Path = styled.path`
//   stroke: ${(props) => props.theme.editor.edgeColor};
//   stroke-width: 3px;
// `;

// const ConnectionLine = ({ fromX, fromY, toX, toY }: ConnectionLineComponentProps) => {
//   return (
//     <g>
//       <Path fill="none" className="animated" d={`M${fromX},${fromY} C ${fromX} ${toY} ${fromX} ${toY} ${toX},${toY}`} />
//     </g>
//   );
// };

// export default ConnectionLine;

import { ConnectionLineComponentProps, getBezierPath } from 'reactflow';
import styled from 'styled-components';

const Path = styled.path`
  stroke: ${(props) => props.theme.global.mainColor};
  stroke-width: 3px;
`;

const ConnectionLine = ({ fromX, fromY, fromPosition, toX, toY, toPosition }: ConnectionLineComponentProps) => {
  const [edgePath] = getBezierPath({
    sourceX: fromX,
    sourceY: fromY,
    sourcePosition: fromPosition,
    targetX: toX,
    targetY: toY,
    targetPosition: toPosition,
  });

  return (
    <g>
      <Path fill="none" className="animated" d={edgePath} />
    </g>
  );
};

export default ConnectionLine;
